import api from '../config';

const path = 'kunde';

export default {
  get: (suche) => api.get(path, { params: { suche } }),
  post: (nummer, name) => api.post(path, { nummer, name }),
};
